import { ThemeProvider as NextThemeProvider } from 'next-themes';
import type { PropsWithChildren } from 'react';

/**
 * Theme wrapper. Dark mode is out of scope for v1 per the scope doc —
 * we force light mode here but keep the provider in place so shadcn's
 * `next-themes`-aware components work without a shim.
 *
 * When dark mode ships (v1.1), swap `forcedTheme` for `defaultTheme` and
 * enable the system-preference detection.
 */
export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme="light"
      forcedTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemeProvider>
  );
}
